var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"omk-list-items-container"},[_c('omk-list',{attrs:{"id":_vm.id,"full-width":""}},_vm._l((_vm.items),function(item,index){return _c('div',{key:index},[_c('omk-list-item',[_c('div',{attrs:{"slot":"headline"},slot:"headline"},[_vm._v(_vm._s(item.physicalAddress))])]),_vm._v(" "),_c('omk-divider',{attrs:{"inset":""}})],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }